import { createAction, props } from '@ngrx/store';

export const updateLookBookNewsFeedId = createAction(
  '[ShopTheLook] Update LookBook News Feed Id',
  props<{ lookBookId?: string; newsfeedId?: string }>(),
);
